<template>
	<div
		class="
			rounded-[2px] bg-[#E9EEF2] px-[6px] py-[2px] font-Inter text-[12px]
			leading-[15px] font-medium tracking-[0.2%] text-won-gray-blue
		"
	>
		{{ progress }}/{{ total }}
	</div>
</template>

<script setup>
defineProps({
	total: {
		type: Number,
		default: 0
	},
	progress: {
		type: Number,
		default: 0
	}
});
</script>